export default {
  slug: "rider",
  code: "RD",
  label: "Rider",
  isIDE: true,
  krakenDir: "Rider",
  thumbnailColor: "#FDB60D",
  logoFamily: "ide",
};
